<template>
    <div>
        <div v-for="(item,index) in tabList" :key="index" :style="item.style" class="myProjectButton"
             @click="showMyBoxFun(index)">
            <div class="div1">
                <i v-show="rightPopupIndex!=index" class="el-icon-d-arrow-left"></i>
                <i v-show="rightPopupIndex==index" class="el-icon-d-arrow-right"></i>
                {{ rightPopupIndex == index ? "收起" : "展开" }}{{ item.name }}
            </div>
        </div>
        <div v-show="rightPopupIndex!=-1" :style="`height:${boxHeight}px;`" class="myProjectBox">
            <my-plan v-show="rightPopupIndex===0" ref="myPlan"></my-plan>
            <scheme-shar v-show="rightPopupIndex===1" ref="schemeShar"></scheme-shar>
            <my-inquiry v-show="rightPopupIndex===2" ref="myInquiry"></my-inquiry>
            <sys-plan v-show="rightPopupIndex===3" ref="sysPlan"></sys-plan>
            <plan-recovery v-show="rightPopupIndex===4" ref="planRecovery"></plan-recovery>
        </div>
    </div>
</template>

<script>
import myInquiry from './inquiry/myInquiry.vue';
import MyPlan from './trip/myPlan.vue';
import {mapState} from "vuex"
import SysPlan from './trip/sysPlan.vue';
import PlanRecovery from './trip/planRecovery.vue';
import SchemeShar from "@/views/plan/rightPopup/trip/schemeShar.vue";

export default {
    components: {SchemeShar, myInquiry, MyPlan, SysPlan, PlanRecovery},
    data() {
        return {
            tabList: [
                {
                    name: "我的方案",
                    style: "top: 1.5rem",
                },
                {
                    name: "分享方案",
                    style: "top: 2.95rem;",
                },
                {
                    name: "我的询单",
                    style: "top: 4.4rem;",
                },
                {
                    name: "方案库",
                    style: "top: 5.85rem",
                },
                {
                    name: "回收站",
                    style: "top: 7.3rem;",
                }
            ],
            boxHeight: 0, //我的询单弹出层的高度
        }
    },
    mounted() {
        this.setboxHeight();
    },
    methods: {
        setboxHeight() {
            var a = window.document.getElementById("app");
            this.boxHeight = document.documentElement.clientHeight - 124;//445
        },
        showMyBoxFun(index, myLineInquiry) {
            if (index === this.rightPopupIndex) {
                this.$store.commit('setCheckIndex', 3)
                this.$store.commit('setRightPopupIndex', -1)
            } else {
                this.$store.commit('setRightPopupIndex', index)
                this.$store.commit('setCheckIndex', 3)
                if (this.rightPopupIndex === 0) {
                    this.$refs.myPlan.getListData('empty')
                }else if(this.rightPopupIndex === 1) {
                    this.$refs.schemeShar.getListData('empty')
                } else if (this.rightPopupIndex === 2) {
                    this.$store.commit('setCheckIndex', 1)
                    this.$refs.myInquiry.getListData('empty')
                } else if (this.rightPopupIndex === 3) {
                    this.$refs.sysPlan.getListData('empty')
                } else {
                    this.$refs.planRecovery.getListData('empty')
                }
            }
        },
    },
    computed: {
        ...mapState(['rightPopupIndex'])
    }
}
</script>

<style lang="scss" scoped>
.myProjectButton {
    position: fixed;
    width: 0.36rem;
    height: 1.3rem;
    background: white;
    right: 0.24rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0.1rem 0.1rem;
    font-size: 0.12rem;
    line-height: 0.17rem;
    cursor: pointer;

    .div1 {
        width: 0.2rem;
        text-align: center;
    }
}

.myProjectBox {
    position: fixed;
    top: 1.5rem;
    width: 7.9rem;
    background: #fafafa;
    z-index: 11;
    right: 0.62rem;
    box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.4);
}
</style>